import AnalyticsEvents_V2, { GenericEvents } from '../analyticsGA4'
import { PortalProducts } from '../types/analytics.type'

class ReferralAnalytics extends AnalyticsEvents_V2 {
  public constructor() {
    super(PortalProducts.REFERRAL)
  }

  public logReferralEmailSent(): void {
    this.logEvent({
      event: 'referral_email_sent',
      title: 'Referral Email Sent',
    })
  }
  public logCTAClick(buttonName: string, title: string): void {
    this.logEvent({
      event: GenericEvents.CTA_CLICK,
      button_name: buttonName,
      title,
    })
  }

  public logModalClose(): void {
    this.logEvent({
      event: GenericEvents.BUTTON_CLICK,
      button_name: 'referral_modal_closed',
      title: 'Referral Modal Closed',
    })
  }
}

const referralAnalytics = new ReferralAnalytics()

export default referralAnalytics
